const byId = (id) => document.getElementById(id);
const appView = document.documentElement.dataset.view === "app";

if (appView) {
  bindConsoleNavigation();
  applyRequestedMode();
}
syncDocumentMetadata();
bindReveals();
void hydrateNetworkChrome();

async function hydrateNetworkChrome() {
  try {
    const [network, report, queue] = await Promise.all([
      fetchJson("/api/network"),
      fetchJson("/api/alpha/report"),
      fetchJson("/api/jobs?state=queued&limit=25")
    ]);
    setText("landing-chain", network.chain?.name || "Robinhood Testnet");
    setText("landing-open-jobs", String(queue.jobs?.length || 0).padStart(2, "0"));
    setText("landing-runs", String(report.totalRuns || 0).padStart(2, "0"));
    setText("landing-settlement", network.settlement?.enabled ? "Escrow live" : "Offline");
    setText("sidebar-network", network.mode?.replaceAll("-", " ") || "Coordinator online");
    setText("overview-network", network.settlement?.enabled ? "TESTNET LIVE" : "Local mode");
    setText("overview-queue", `${queue.jobs?.length || 0} open`);
  } catch {
    setText("landing-open-jobs", "Offline");
    setText("landing-runs", "—");
    setText("landing-settlement", "UNAVAILABLE");
    setText("sidebar-network", "Coordinator unavailable");
    setText("overview-network", "Offline");
  }
}

async function fetchJson(path) {
  const response = await fetch(path, { headers: { accept: "application/json" } });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
}

function setText(id, value) {
  const element = byId(id);
  if (element) element.textContent = value;
}

function bindConsoleNavigation() {
  const links = [...document.querySelectorAll(".app-nav a")];
  for (const link of links) {
    link.addEventListener("click", (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      history.pushState({}, "", link.href);
      renderAppRoute(links);
      byId("app-main")?.focus({ preventScroll: true });
      scrollTo({ top: 0, behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
    });
  }
  addEventListener("popstate", () => renderAppRoute(links));
  renderAppRoute(links);
}

function renderAppRoute(links) {
  const route = getAppRoute();
  document.documentElement.dataset.appRoute = route;
  for (const section of document.querySelectorAll("[data-app-page]")) {
    section.hidden = !section.dataset.appPage.split(/\s+/).includes(route);
  }
  for (const link of links) {
    const active = link.dataset.route === route;
    link.classList.toggle("is-active", active);
    if (active) link.setAttribute("aria-current", "page");
    else link.removeAttribute("aria-current");
  }
  if (route === "earn") {
    setText("network-eyebrow", "EARN WITH YOUR GPU");
    setText("network-title", "Pick a bounty.");
  } else if (route === "create") {
    setText("network-eyebrow", "CREATE WITH THE NETWORK");
    setText("network-title", "Generate an image.");
  }
  syncDocumentMetadata();
}

function getAppRoute() {
  const segment = location.pathname.replace(/^\/app\/?/, "").split("/")[0];
  return ["create", "earn", "device", "activity", "verify", "admin"].includes(segment) ? segment : "home";
}

function applyRequestedMode() {
  const mode = new URLSearchParams(location.search).get("mode");
  if (!mode) return;
  document.documentElement.dataset.mode = mode;
}

function syncDocumentMetadata() {
  if (!appView) return;
  const route = getAppRoute();
  const titles = {
    home: "Workspace",
    create: "Create",
    earn: "Earn",
    device: "Device",
    activity: "Activity",
    verify: "Verify",
    admin: "Network admin"
  };
  document.title = `${titles[route]} — ShareMyAI`;
  const description = document.querySelector('meta[name="description"]');
  if (description) description.content = "Create with open models, earn by running requests, and follow every result through the ShareMyAI network.";
}

function bindReveals() {
  if (!("IntersectionObserver" in globalThis) || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const items = [...document.querySelectorAll(appView
    ? "[data-app-page]:not([hidden])"
    : ".landing-main > section")];
  if (!items.length) return;

  // Only what starts below the fold. Hiding the first screen and waiting for an
  // observer to give it back means the page is blank until the callback runs,
  // and on this app the main thread is busy enough at load that it took several
  // seconds. Nothing a visitor can already see is ever hidden.
  const fold = innerHeight;
  const hidden = items.filter((item) => item.getBoundingClientRect().top > fold);
  if (!hidden.length) return;
  for (const item of hidden) item.dataset.reveal = "";
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add("is-visible");
      observer.unobserve(entry.target);
    }
  }, { rootMargin: "0px 0px -8%", threshold: .08 });
  requestAnimationFrame(() => {
    document.documentElement.classList.add("reveal-ready");
    for (const item of hidden) observer.observe(item);
  });
}
